export default "__VITE_ASSET__5P7_ZnuZ__"